var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"shadow text-center align-middle",attrs:{"bg-variant":"danger","text-variant":"light","border-variant":"secondary"}},[_c('b-card-title',[_vm._v("\n        🚫 Forbidden Access 🚫\n    ")]),_vm._v(" "),_c('b-card-text',[_vm._v("\n        You have no business accessing this application. Go somewhere else, be productive.\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f10aba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Forbidden.vue
// module id = null
// module chunks = 